import classNames from 'classnames';
import { ThemeFile, ThemeName } from 'lib/context/ThemeContext';
import { BorderStyle, TextAlignment } from './SectionHeadline';

const awHeadlineClasses = 'text-s md:text-m font-heavy pb-xs mb-s';

const rbaHeadlineClasses = 'text-m md:text-l font-extra-light pb-xs mb-s';

const getBorderClasses = (theme: ThemeName, borderStyle: BorderStyle) => {
  const borderColorMap = {
    aw: {
      default: '',
      dark: 'border-b-6 border-primary',
      light: 'border-b-6 border-light-gray',
      primary: 'border-b-6 border-primary',
    },
    rba: {
      default: '',
      dark: 'border-b-3 border-secondary',
      light: 'border-b-3 border-gray',
      primary: 'border-b-3 border-primary',
    },
  };
  return borderColorMap[theme][borderStyle];
};

const getDynamicStyles = (
  theme: ThemeName,
  alignment: TextAlignment,
  borderStyle: BorderStyle
): string => {
  return classNames(`text-${alignment}`, getBorderClasses(theme, borderStyle));
};

export const SectionHeadlineTheme = (
  alignment: TextAlignment,
  borderStyle: BorderStyle
): ThemeFile => {
  return {
    aw: {
      classes: {
        headlineContainer: classNames(
          awHeadlineClasses,
          getDynamicStyles('aw', alignment, borderStyle)
        ),
      },
    },
    rba: {
      classes: {
        headlineContainer: classNames(
          rbaHeadlineClasses,
          getDynamicStyles('rba', alignment, borderStyle)
        ),
      },
    },
  };
};
